import { useStore } from '@nanostores/react';
import { memo } from 'react';
import { CapacityTable } from './CapacityTable';
import { MonthlySpendingLimit } from './MonthlySpendingLimit';
import { SectionContainer } from '~/components/dialogs/settings/SectionContainer';
import { Link } from '~/components/ui/Link';
import { userStore } from '~/lib/stores/user';
import { HELP_CENTER_HOSTING } from '~/lib/urls';

export const Hosting = memo(() => {
  const isPaidUser = useStore(userStore.isPaidUser);

  return (
    <SectionContainer title="Cloud">
      <section className="flex flex-col gap-6">
        <div className="flex justify-between">
          <h3 className="text-sm font-semibold text-bolt-ds-textTertiary">Capacity</h3>
          <Link className="text-sm decoration-none" href={`${HELP_CENTER_HOSTING}#bolt-hosting-plans`} target="_blank">
            Learn more about hosting capacity
          </Link>
        </div>
        {isPaidUser && <MonthlySpendingLimit />}
        <CapacityTable isFreeUser={!isPaidUser} />
      </section>
    </SectionContainer>
  );
});

Hosting.displayName = 'Hosting';
